/**
 * Locks document scrolling while any modal (or modal-like UI) is open.
 * Uses html[scroll-lock] (see base.css) and keeps state in sync via DOM observation.
 */
(function () {
  /** @type {number} */
  let manualLockCount = 0;

  /** @type {boolean} */
  let scheduled = false;

  /**
   * @param {Element} el
   * @returns {boolean}
   */
  function isVisible(el) {
    if (!(el instanceof HTMLElement)) return false;
    if (el.hasAttribute('hidden')) return false;
    if (el.classList.contains('rs-hidden')) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;

    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    return true;
  }

  /**
   * @returns {boolean}
   */
  function hasOpenModalInDom() {
    if (document.querySelector('dialog[open]')) return true;
    if (document.querySelector('details[scroll-lock][open]')) return true;
    if (document.body.classList.contains('rs-mobile-menu-open')) return true;
    if (document.getElementById('b2b-address-validation-modal')) return true;

    const contextSwitchOverlay = document.getElementById('rs-context-switch-overlay');
    if (contextSwitchOverlay && isVisible(contextSwitchOverlay)) return true;

    // Coveo PLP/search add-to-list (`coveo-add-to-list` uses `.modal.open`, not `.rs-modal`)
    if (document.querySelector('.modal.open')) return true;

    if (document.querySelector('.rs-pld-modal-overlay')) return true;

    for (const el of document.querySelectorAll('.rs-modal')) {
      if (isVisible(el)) return true;
    }

    for (const el of document.querySelectorAll('[role="dialog"], [aria-modal="true"]')) {
      if (isVisible(el)) return true;
    }

    return false;
  }

  function update() {
    const shouldLock = manualLockCount > 0 || hasOpenModalInDom();

    if (shouldLock) {
      document.documentElement.setAttribute('scroll-lock', '');
    } else {
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  window.RsScrollLock = {
    lock() {
      manualLockCount += 1;
      update();
    },
    unlock() {
      manualLockCount = Math.max(0, manualLockCount - 1);
      update();
    },
    update,
  };

  document.addEventListener(
    'toggle',
    (event) => {
      if (
        event.target instanceof HTMLDialogElement ||
        (event.target instanceof HTMLDetailsElement && event.target.hasAttribute('scroll-lock'))
      ) {
        scheduleUpdate();
      }
    },
    { capture: true }
  );

  function startObserving() {
    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'aria-modal', 'hidden'],
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
